import { format } from 'date-fns';
import { toast } from 'react-toastify';

import { setSuccess } from '../actions/loadingActions';
import { FORM_SUBMISSION_SUCCESS } from '../constants/generals';
import { IHistory } from '../interfaces';
import { ChecklistModel } from '../model/ChecklistModel';
import { IQuarterlyFormModelProps, QuarterlyFormModel } from '../model/QuarterlyFormModel';
import { getCurrentUserUUID, getImageData, marshallChecklistData, marshallFormDetails, objectToArray } from '../utils/generalUtils';
import { getDev, postDev, putDev } from '../utils/HTTPDev';
import { uploadImages } from './formService';
import { getAllPlantsByRegion } from './plantService';
import { QuestionModel } from '../model/QuestionModel';

export async function getQuarterlyFormList(q: string, yyyy: string, type: string, region?: string) {
    const allInstances = QuarterlyFormModel.list();
    allInstances.forEach(instance => {
        new QuarterlyFormModel(instance.props).$delete();
    });
    try {
        const response = await getDev(`/forms-q/${q}${yyyy}/${getCurrentUserUUID()}/${region || 'All'}`);
        (response.data.data ? response.data.data : []).forEach(element => {
            element.id = element.InspectionUId;
            element.type = element.InspectionId;
            element.Date = format(element.Date, 'MM/DD/YYYY');
            const dateFormatted = format(element.ActualDate, 'MM/DD/YYYY');
            element.SubmittedDate = dateFormatted; 
            element.UpdatedDate = element.UpdatedDate ? format(element.UpdatedDate, 'MM/DD/YYYY') : 'N/A';
            new QuarterlyFormModel(element).$save();
        });
        setSuccess('QuarterlyFormList');
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getQuarterlyFormDetails(formId) {
    try {
        const response = await getDev(`/getanswers/${formId}`);
        const questionsData: IQuarterlyFormModelProps = { id: '', questions: [], ImageUrls: [], Completed: false };
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.UserName,
            question: 'Submitted By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: format(response.data.data.ActualDate, 'MM/DD/YYYY'),
            question: 'Submission Date',
            flaggedQuestion: false
        });
        
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.UpdatedBy ? response.data.data.UpdatedBy : 'N/A',
            question: 'Updated By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer:  response.data.data.UpdatedDate ? format(response.data.data.UpdatedDate, 'MM/DD/YYYY'):'N/A', 
            question: 'Updated Date',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.PlantId,
            question: 'Plant Id',
            flaggedQuestion: false
        });
        objectToArray(response.data.data.Answers).forEach((formDetails, index) => {
            const instance = marshallFormDetails(formDetails, index, formId);
            questionsData.questions.push(instance);
        });
        if (response.data.data.Completed === 1) {
            questionsData.CompletedBy = response.data.data.CompletedBy;
            questionsData.DateCompleted = format(response.data.data.DateCompleted, 'MM/DD/YYYY');
            questionsData.FollowUpComments = response.data.data.FlaggedComments;
        }
        questionsData.id = formId;
        questionsData.Completed = response.data.data.Completed !== 0;
        questionsData.Flagged = response.data.data.Flagged !== 0;
        questionsData.ImageUrls = response.data.data.ImageUrls;
        questionsData.SignatureUrls = response.data.data.SignatureUrls;
        questionsData.type = response.data.data.FormType;
        questionsData.Date = format(response.data.data.Date, 'MM/DD/YYYY');
        questionsData.SubmittedDate = format(response.data.data.ActualDate, 'MM/DD/YYYY');

        new QuarterlyFormModel(questionsData).$save();
    } catch (error) {
        throw error;
    }
}

export async function submitQuarterlyForm(data, history: IHistory, images: string[], formId: string) {
    try {
        let response = null;
        /* const ImageUrls = await uploadImages(images, 'images');
        data.ImageUrls = ImageUrls; */
        let SignatureData: any = []; 
        if(data.SignatureData) {
            let signature = getImageData(data.SignatureData, 'signatureData');
            SignatureData.push(signature); 
        }
        let ImageData: any = []; 
        if(images) {
            (images || []).forEach((item: string) => { 
                let image = getImageData(item, 'images');
                ImageData.push(image); 
            })
        }
        data.SignatureData = SignatureData;
        data.ImageData = ImageData;
        if (formId) {
            const updateData = {
                Answers: data.Answers,
                UserId: getCurrentUserUUID(),
                InspectionID: data.InspectionID,
                Date: data.Date,
                ImageUrls: data.ImageUrls,
                DeletedImages: data.DeletedImages,
                SignatureUrls: data.SignatureUrls,
                SignatureData: data.SignatureData || [],
                ImageData: data.ImageData || []
            };
            response = await putDev(`/updateform/${formId}`, updateData);
        } else {
            response = await postDev('/form', data);
        }
        toast.success(FORM_SUBMISSION_SUCCESS, {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            autoClose: 1000,
            onClose: () => history.push('/inspections')
        });
        await getAllPlantsByRegion(getCurrentUserUUID(), 'All');
        return response;
    } catch (error) {
        toast.error('Something went wrong please try again later...!!', {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast',
            autoClose: 1000
        });
        throw error;
    }
}

export async function getQuarterlyChecklistData(plantId: string, yyyy = format(new Date(), 'YYYY'),
    formType: string, outfall: string) {
    try {
        const response = await getDev(`/getquarterlyforms/${plantId}/${yyyy}/${formType}/Outfall${outfall}`);
        let flag = true;
        const answersData = marshallChecklistData(response.data.data);
        answersData.sort((a, b) => {
            return a.month - b.month;
        });
        new ChecklistModel({ id: plantId, answers: answersData, type: formType }).$save();
    } catch (error) {
        throw error;
    }
}

function marshallQuestionAndAnswers(instance, answers, index, type) {
    const newInstance = {
        question: instance.Question,
        quesNum: instance.Question_Num,
        type: type,
        id: index,
        quesName: `q${instance.Question_Num}`,
        answer: null
    };
    const skipForBooleanAnswer = ['submitted by', 'time started', 'time water sampled', 'sampling name',
        'sampling title', 'nature of discharge', 'why not?', 'color', 'odor', 'clarity', 'turbidity',
        'other obvious indiciators of storm water pollution?', 'why?', 'probable sources of pollutants:',
        'if applicable, explain corrective actions taken since the last inspection:',
        'if any incidents of non-compliance were indentified during the inspection, discuss corrective actions needed:',
        'changes required to the swp3:', 'weather'];
    if (skipForBooleanAnswer.indexOf(instance.Question.toLowerCase()) >= 0) {
        newInstance.answer = answers.answer;
    } else if (instance.Question.toLowerCase() === 'date') {
        newInstance.answer = new Date(answers.answer);
    } else if (type === 'QTRVisual') {
        newInstance.answer =
            answers.question === instance.Question ? answers.answer : '';

    } else {
        newInstance.answer = (answers.question === instance.Question) ? answers.answer : null;

    }
    return newInstance;
}

export async function getQuarterlyFormAnswers(formId: string) {
    try {
        const response = await getDev(`/getanswers/${formId}`);
        const questionsData: IQuarterlyFormModelProps = { id: '', questions: [], ImageUrls: [], Completed: false }; 
        objectToArray(response.data.data.Answers).reverse().forEach((formDetails, index) => {
            const instance = marshallFormDetails(formDetails, index, formId);
            questionsData.questions.push(instance);
        });
        questionsData.id = formId;
        questionsData.ImageUrls = response.data.data.ImageUrls;
        questionsData.SignatureUrls = response.data.data.SignatureUrls;
        return questionsData;
    } catch (error) {
        throw error;
    }
}

export async function getQuarterlyFormQuestions(type: string, formId?: string) {
    try {
        const response = await getDev(`/getquestions/${type}`);
        let formInstance = null;
        if (formId) {
            formInstance = await getQuarterlyFormAnswers(formId); 
        }
        if( (type=='QTRVisual' || type=='ShopInspection' ) && formId) {
            response.data.data.pop();
            response.data.data.pop();
        }
        (response.data.data || []).reverse().forEach((instance, index) => {
            const newInstance = {
                question: instance.Question,
                quesNum: instance.Question_Num,
                type: type,
                id: index,
                quesName: `q${instance.Question_Num}`,
            };
            if (formId) { 
                if( (type=='QTRVisual' || type=='ShopInspection' ) ) {
                    if(instance.Question.toLowerCase() === 'acknowledged by' || instance.Question.toLowerCase() === 'actual date') {
                        return;
                    }
                }
                const modelInstance = marshallQuestionAndAnswers(instance, formInstance.questions[index], index, type);
                new QuestionModel(modelInstance).$save();
                const questionsData: IQuarterlyFormModelProps = {};
                questionsData.id = formId;
                questionsData.ImageUrls = formInstance.ImageUrls;
                questionsData.SignatureUrls = formInstance.SignatureUrls;
                questionsData.Completed = formInstance.Completed !== 0; 
                new QuarterlyFormModel(questionsData).$save();
            } else {
                new QuestionModel(newInstance).$save();
            }
        });
    } catch (error) {
        toast.error('Something went wrong please try again later...!!', {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/quarterlyFormService.ts